import axios from 'axios';

var axios_request = axios.create({
    baseURL: process.env.VUE_APP_ADMIN_ENDPOINT_BASE_URL,
    headers: {'Content-Type': 'application/json'}
});

const getConfig = headerparams => {
    return { headers: { 'authorization': '', ...headerparams }};
};

/////////////////////////////////////

export const getTaskDetail = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_sales_tasks_data');
    apiFormData.set('task_date', params.task_date);
    apiFormData.set('sales_person_hash', params.sales_person_hash);
    apiFormData.set('action_type', params.action_type);
    apiFormData.set('task_id', params.task_id);
    apiFormData.set('task_hash', params.task_hash);
    apiFormData.set('field', params.field);
    apiFormData.set('value', params.value);

    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const sendDutyListEmail = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'send_duty_notes_email');
    apiFormData.set('task_date', params.task_date);
    apiFormData.set('sales_person_hash', params.sales_person_hash);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getTaskList = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_task_list_data');
    apiFormData.set('days_back', params.days_back);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}

export const getCustomerListResults = (params, headerparams) => {
    var apiFormData = new FormData();
    apiFormData.set('f', 'get_customer_searchstring');
    apiFormData.set('searchstring', params.searchstring);
    return axios_request.post(
        `leaflinkapi.php`,
        apiFormData,
        getConfig({'Content-Type': 'multipart/form-data',...headerparams})
    )
}






